/**
 * "Shared access · {ownerName}" badge for pumps shared with the user
 * but not owned by them. Mirrors the iOS pump-card ownership tag (per
 * migration 091). The component name + ownership='following' enum
 * value stay (DB column = device_followers); only the visible label
 * changed.
 */
export function FollowingBadge({
  ownerDisplayName,
}: {
  ownerDisplayName: string | null;
}) {
  return (
    <span
      className="badge"
      style={{
        backgroundColor: 'rgba(1, 157, 220, 0.10)',
        color: 'var(--aqua-primary)',
        fontWeight: 500,
        fontSize: '0.72rem',
        padding: '0.25rem 0.5rem',
      }}
    >
      Shared access{ownerDisplayName ? ` · ${ownerDisplayName}` : ''}
    </span>
  );
}
